export default "__VITE_ASSET__DVSNSgvf__"